import * as constants from "./../constants";

export interface DataLoadedAction {
  type: constants.DATA_LOADED | constants.DATA_REQUESTED;
}

export interface RequestInProgressAction {
  type: constants.REQUEST_IN_PROGRESS;
}

export function dataLoaded(): DataLoadedAction {
  return {
    type: constants.DATA_LOADED,
  };
}

export function dataRequested(): DataLoadedAction {
  return {
    type: constants.DATA_REQUESTED,
  };
}


export function requestInProgress(): RequestInProgressAction {
  return {
    type: constants.REQUEST_IN_PROGRESS,
  };
}
